import { useMutation } from '@tanstack/react-query';

import { createTelemetryEvent } from '../api/feedback.api';

interface CreateTelemetryEventParams {
    id: number;
    est: number | null;
}

export const useCreateTelemetryEvent = () => {
    return useMutation({
        mutationFn: ({ id, est }: CreateTelemetryEventParams) =>
            createTelemetryEvent(id, est),
    });
};
